// User-facing wording for entitlement/reservation errors.
// Wire messages (ERROR_CONTRACT in entitlementReservationClient) are protocol-checked
// against the backend and must not change; translate them at display time only.
export const DISPLAY_MESSAGES = {
  AUTHENTICATION_REQUIRED: "Your session has expired. Please sign in again.",
  FORBIDDEN: "You don't have permission to do this.",
  INVALID_REQUEST: "Something went wrong with this request. Please try again.",
  RATE_LIMITED: "You're doing that too quickly. Please wait a moment and try again.",
  ENTITLEMENT_UNAVAILABLE: "The billing service is temporarily unavailable. Please try again in a moment.",
  INTERNAL_ERROR: "We couldn't complete this request. Please try again in a moment.",
  IDEMPOTENCY_KEY_REUSED: "This request was already processed. Please refresh and try again.",
  RESOURCE_NOT_FOUND: "We couldn't find the record for this request. Please refresh and try again.",
  CONFIRMATION_TOKEN_INVALID: "This confirmation is no longer valid. Please try saving again.",
  QUOTE_EXPIRED: "This cost estimate has expired. Please try saving again to get a new one.",
  QUOTE_SNAPSHOT_STALE: "This cost estimate is out of date. Please try saving again to get a new one.",
  UNSUPPORTED_WORKFLOW: "This action isn't available for your account.",
  INVALID_UNITS: "We couldn't count the images for this request. Please try again.",
  INSUFFICIENT_CAPACITY: "There isn't enough balance for this batch. Nothing was uploaded.",
  PERMISSION_CONFLICT: "There was a conflict while starting the upload. Please try again.",
  EFFECT_CONFLICT: "This request was already completed with a different result. Please refresh the page.",
  RESERVATION_OUTCOME_UNKNOWN: "We couldn't confirm whether this image finished uploading. Please check the image list in a moment and re-upload any image that didn't complete.",
  RECONCILIATION_FAILED: "We couldn't update your balance automatically. Nothing is lost — please try again in a moment.",
  NETWORK_OFFLINE: "You are offline. Your data is safe on this device — reconnect to continue.",
  UPLOAD_FAILED: "We couldn't upload this image. Please try again.",
  UPLOAD_OUTCOME_UNKNOWN: "We couldn't confirm whether this image finished uploading. Please re-upload this image — the image list shows its current state.",
  UPLOAD_NOT_VERIFIED: "This image's upload couldn't be confirmed in time. Please re-upload this image.",
  UPLOAD_OBJECT_ABSENT: "This image didn't reach the server. Please re-upload it.",
};

export const entitlementDisplayMessage = (error, fallback) => {
  const code = error && error.code;
  if (code && DISPLAY_MESSAGES[code]) return DISPLAY_MESSAGES[code];
  if (error && typeof error.message === "string" && error.message) return error.message;
  return fallback;
};
